import React from "react";

import { useNavigate } from "react-router-dom";

import { shareEnabled, assetOrigin, assetBase } from "../../config";
import GridItem from "../../partials/gridItem";
import ListItem from "../../partials/listItem";
import FavouriteBtn from "../../partials/favouriteBtn";
import { useWindowSize } from "../../partials/windowSize";
import { logCustomEvent } from "../../core/analytics";
import ShareBtn from "../../partials/shareBtn";

import { Col } from "react-bootstrap";
import { Button } from "@mui/material";
import OpenNewIcon from "@mui/icons-material/OpenInNewOutlined";

// The document API exposes the file under a single `field_document` key. For a
// published/modified row that value is the signed relative asset
// (`assets/<file>?sig=…`) captured in book.json — resolved same-origin off
// assetBase. An unpublished row carries the absolute private URL, which opens
// as-is.
const documentFileUrl = (item) => {
  const file = item?.field_document;
  if (!file) return undefined;
  return file.startsWith("http")
    ? file
    : `${assetBase}/document/${item.id}/${item.id}/${file}`;
};

export default function DocumentItem(props) {
  const { width } = useWindowSize();
  const navigate = useNavigate();

  let listItem = {
    id: props.item?.id,
    title: props.item?.title,
    category_label: props.item?.category_labels,
    className: "document",
  };

  if (props.creator) {
    const imgSrc = props.item?.thumbnail
      ? `${assetOrigin}${props.item.thumbnail}`
      : "";
    return (
      <>
        <GridItem
          xs={12}
          sm={6}
          lg={3}
          xl={3}
          xxl={2}
          itemClass="document"
          item={props.item}
          bundle={props.item?.bundle}
          id={props.item?.id}
          title={props.item?.title}
          field_body={props.item?.summary ?? ""}
          category_label={props.item.category_labels}
          created={props.item?.created}
          hasImg={true}
          imgSrc={imgSrc}
          alt={`Poster for Document ${props.item.id}`}
          cardActionArea={true}
          creator={props.creator}
          cardActionCallBack={
            props.creator
              ? () => {}
              : () => navigate(`/documents/view/${props.item?.id}`)
          }
          contentType={props.contentType}
          viewOverride={documentFileUrl(props.item)}
          shareEnabled
          route={"documents"}
          field_access_token={props.item.access_token}
          sharePrompt={`This is a public link that enables you to share the document with your client, no login required.`}
        ></GridItem>
      </>
    );
  } else {
    return (
      <>
        {props.gridView && (
          <GridItem
            xs={12}
            md={3}
            itemClass="document"
            bundle={props.item?.bundle}
            title={props.item?.title}
            field_body={props.item?.summary ?? ""}
            cardActionArea={true}
            cardActionCallBack={() => {
              const url = documentFileUrl(props.item);
              if (url) {
                window.open(url, "_blank");
              }
            }}
            cardActions={true}
            category_label={props.item?.category_labels}
          >
            {shareEnabled && (
              <ShareBtn
                className="share-col ps-0"
                id={props.item?.id ?? props.item?.nid}
                contentType={props.contentType}
                title={props.item?.title}
                route={"documents"}
                field_access_token={props.item.field_access_token}
                sharePrompt={`This is a public link that enables you to share the document with your client, no login required.`}
              />
            )}
            <Col xs={"auto"} className="d-flex align-items-center">
              <Button
                variant="screenItemBtn"
                mode="default"
                onClick={() => {
                  const url = documentFileUrl(props.item);
                  if (url) {
                    window.open(url, "_blank");
                    logCustomEvent("read", props.item, "Document");
                  }
                }}
              >
                <OpenNewIcon sx={{ fontSize: "0.9rem" }} />
              </Button>
            </Col>
            <FavouriteBtn
              id={props.item?.id ?? props.item?.nid}
              contentType={props.contentType}
              mode={"default"}
            />
          </GridItem>
        )}
        {!props.gridView && (
          <ListItem
            active={props.activeDetail === props.item?.id}
            owner="client"
            item={listItem}
            idEnabled={width < 576 ? false : true}
            categoryEnabled={width < 768 ? false : true}
            category_label={props.item?.category_labels}
            infoBtn
            handleInfo={() => props.setActiveDetails(props.item?.id)}
            infoDisabled={!props.item?.summary && !props.item?.body}
            openBtn
            openBtnDisabled={!documentFileUrl(props.item)}
            handleOpen={() => {
              const url = documentFileUrl(props.item);
              if (url) {
                window.open(url, "_blank");
                logCustomEvent("read", props.item, "Document");
              }
            }}
            accordInfo
            accordInfoBody={props.item?.summary ?? ""}
            contentType={props.contentType}
            shareLink={
              props.item.access_token
                ? `${window.location.origin}/documents/view/${props.item?.id}?hash=${props.item.access_token}`
                : "share link not available"
            }
            sharePrompt={`This is a public link that enables you to share the document with your client, no login required.`}
          ></ListItem>
        )}
      </>
    );
  }
}
